import React from "react";
import { header, header2, header3, leaf2, mainLeaf } from "../../assets";
import {
  BiLogoFacebook,
  BiLogoInstagramAlt,
  BiLogoYoutube,
  BiLogoTwitter,
  BiLogoLinkedin,
} from "react-icons/bi";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import HomeSlide from "../../Components/HomeSlide";
import { motion } from "framer-motion";

const Header = () => {
  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 10000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <motion.div
      id="header"
      whileInView={{ y: [50, 0] }}
      transition={{ duration: 0.7 }}
    >
      <img src={mainLeaf} alt="" className="mainLeaf1" />
      <img src={leaf2} alt="" className="mainLeaf2" />
      

      <Slider {...settings} className="slider">
        <div>
          <HomeSlide
            banner={header}
            heading="Bangladesh's Premier Beauty Clinic: Elevating Natural Beauty"
            desc="Bangladesh's top beauty clinic is a leading destination for state-of-the-art cosmetic and aesthetic treatments. Renowned for its skilled professionals and dedication to enhancing natural beauty, it offers a wide array of services, ensuring excellent results and client satisfaction."
          />
        </div>
        <div>
          <HomeSlide
            banner={header2}
            heading="The only ISO CERTIFIED Beautycinology clinic in Bangladesh"
            desc="Bangladesh's premier beauty clinic is a trusted hub for top-quality cosmetic and aesthetic treatments. With a focus on enhancing natural beauty, it offers a wide range of services, making it the go-to choice for premium beauty enhancements in the country."
          />
        </div>
        <div>
          <HomeSlide
            banner={header3}
            heading="Your Ultimate Choice for Premium Beauty Enhancements in Bangladesh"
            desc="Bangladesh's top beauty clinic is known for excellence in cosmetic treatments, emphasizing natural beauty. It's the go-to choice for premium beauty enhancements in the country."
          />
        </div>
      </Slider>
    </motion.div>
  );
};

export default Header;
